import { render, staticRenderFns } from "./StatisticsMarksByDepartmentView.vue?vue&type=template&id=30479520"
import script from "./StatisticsMarksByDepartmentView.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksByDepartmentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports